// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UpCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/UpCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var UpCircleTwoTone = function UpCircleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UpCircleTwoToneSvg
  }));
};

UpCircleTwoTone.displayName = 'UpCircleTwoTone';
export default React.forwardRef(UpCircleTwoTone);